<template>
  <div v-if="cardData && [1, 3].includes(cardData.flag)" class="enterprise-card">
    <div class="title">
      <p>企业卡</p><span @click="onGoCard">查看<i class="icon-arrowR" /></span>
    </div>
    <div class="content">
      <div class="top">
        <div class="pic">
          <img v-if="cardData.cardType === 1" src="https://nl-frontend-test-1305297355.cos.ap-beijing.myqcloud.com/nl-saas/overview/card-bg1.png" alt="">
          <img v-if="cardData.cardType === 2" src="https://nl-frontend-test-1305297355.cos.ap-beijing.myqcloud.com/nl-saas/overview/card-bg2.png" alt="">
          <div v-if="cardData.cardType === 2" class="price">{{ ((cardData.couponReduction / 100) * cardData.couponTimes).toFixed(1) }}<span class="small">元</span></div>
          <div v-if="cardData.cardType === 1" class="price">{{ cardData.discountProportion/10 }}<span class="small">折</span></div>
        </div>
        <div class="info">
          <p>已优惠金额</p>
          <p class="amount">¥<span>{{ splitNumberString(cardData.discountedAmount/100).integer }}.</span>{{ splitNumberString(cardData.discountedAmount/100).decimal }}</p>
        </div>
      </div>
      <div class="desc-list">
        <div class="desc-list--item"><label>适用范围：</label>{{ energyType }}</div>
        <div class="desc-list--item"><label>使用规则：</label>
          <span v-if="cardData.cardType === 2">满{{ cardData.couponFull/100 }}元减{{ cardData.couponReduction/100 }}元</span>
          <span v-if="cardData.cardType === 1">企业支付订单享{{ cardData.discountProportion/10 }}折优惠
            {{ cardData.discountSingleToplimitFlag === 1 ? `，单笔最高优惠${cardData.discountSingleToplimit/100}元` : '' }}
          </span>
        </div>
        <div class="desc-list--item"><label>使用情况：</label>
          <span v-if="cardData.cardType === 2">共{{ cardData.couponTimes }}次（剩余<b class="blone">{{ cardData.couponTimes-cardData.usageCount }}</b>次）</span>
          <span v-if="cardData.cardType === 1 && cardData.discountTimesFlag">共{{ cardData.discountTimes }}次（剩余<b class="blone">{{ cardData.discountTimes-cardData.usageCount }}</b>次）</span>
          <span v-if="cardData.cardType === 1 && !cardData.discountTimesFlag">已用<b class="blone">{{ cardData.usageCount }}</b>次</span>
        </div>
        <div class="desc-list--item"><label>有效时间：</label>
          <span v-if="cardData.endTime < 4088937599000">{{ formatDate(cardData.startTime, 'YYYY.MM.DD') }}-{{ formatDate(cardData.endTime, 'YYYY.MM.DD') }}</span>
          <span v-else>长期有效</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineComponent, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import router from '@/router';
import { formatDate } from '@/core/filters';
import { splitNumberString } from '@/utils/illuminate';

const store = useStore();
console.log(store.state.User.businessCardDetail, '----store.state.User.businessCardDetail');
const cardData = computed(() => (store.state.User.businessCardDetail));
console.log(cardData, '----cardData');
const energyType = computed(() => cardData.value.energyType && cardData.value.energyType.split(',').map(item => {
  switch (item) {
    case 'gasoline': return '汽油';
    case 'diesel_oil': return '柴油';
    case 'natural_gas': return '天然气';
    case 'electricity': return '电';
    default: break;
  }
}).join('、'));

const getEnterpriseCardDetailFun = () => {
  try {
    store.dispatch('User/getBusinessCardDetail');
  } catch (e) {
    store.dispatch('User/setBusinessCardDetail', null);
  }
};
const onGoCard = () => {
  router.push({ name: 'business.card' });
};
onMounted(() => {
  getEnterpriseCardDetailFun();
});
</script>

<style lang="scss" scoped>
.enterprise-card {
  margin-top: 16px;
  border-radius: 16px;
  background: #fff;
  padding: 20px;

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    p {
      color: #1d2129;
      font-size: 20px;
      font-weight: 600;
      line-height: 32px; /* 160% */
    }

    span {
      display: flex;
      align-items: center;
      color: #4e5969;
      font-size: 14px;
      font-weight: 500;
      line-height: 32px; /* 228.571% */
      cursor: pointer;

      .icon-arrowR {
        width: 16px;
        height: 16px;
        background: url(https://nl-frontend-test-1305297355.cos.ap-beijing.myqcloud.com/nl-saas/overview/card-left.png) no-repeat center center;
        background-size: cover;
      }
    }
  }

  .content {
    border-radius: 12px;
    background: #f6f9ff;
    padding: 16px 20px;

    .top {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .pic {
        width: 123px;
        height: 72px;
        margin-right: 16px;
        position: relative;

        img {
          width: 100%;
          height: 100%;
          display: inline-block;
        }

        .price {
          color: #fff;
          font-family: D-DIN;
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: 20px; /* 100% */
          position: absolute;
          bottom: 10px;
          left: 10px;

          .small {
            color: #fff;
            font-family: D-DIN;
            font-size: 12px;
            font-style: normal;
            font-weight: 700;
            line-height: 20px;
          }
        }
      }
      

      .info {
        p {
          color: #86909c;
          font-size: 14px;
          font-weight: 400;
          line-height: 24px; /* 171.429% */
        }

        .amount {
          color: #1d2129;
          font-size: 20px;
          font-weight: 700;
          line-height: 32px; /* 160% */
          font-family: D-DIN;

          span {
            color: #1d2129;
            font-size: 28px;
            font-weight: 700;
            line-height: 32px;
          }
        }
      }
    }

    .desc-list {
      padding-top: 16px;
      border-top: solid 1px rgba(41, 130, 255, 0.1);

      &--item {
        color: #4e5969;
        font-size: 12px;
        font-weight: 600;
        line-height: 24px;

        b {
          color: #2982ff;
        }

        label {
          color: #86909c;
          font-size: 12px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
